// Copyright (c) 2019 Deere & Company

import OktaState from './components';
import actionCreators from './action-creators';
import { connect } from 'react-redux';

const getStateToBindToContainerProps = state => ( {
    ...state.oktaState
} );

const mapBoundActionCreatorsToActionsProp = ( stateProps, dispatchProps ) => ( {
    ...stateProps,
    actions: {
        ...dispatchProps
    }
} );

export default connect(
    getStateToBindToContainerProps,
    actionCreators,
    mapBoundActionCreatorsToActionsProp,
)( OktaState );
